// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__rutrR","load8":"Spinner_load8__yjxlJ"};